export default "__VITE_ASSET__DzGRv_pM__"